import dynamic from "next/dynamic";
import { ComponentConfig } from "@zapier/builder.io-kit";

export const planCardCollectionV2Config: ComponentConfig = {
  name: "PlanCardCollectionV2",
  category: "Pricing",
  friendlyName: "PlanCardCollection",
  component: dynamic(() => import("./PlanCardCollectionV2")),
  includeScrollTracking: true,
  inputs: [
    {
      name: "stateKey",
      type: "string",
      required: true,
      helperText:
        "An identifier that should match any other component(s) on the page that should cause this component to be updated.",
    },
    {
      name: "plans",
      type: "list",
      subFields: [
        {
          name: "type",
          type: "string",
          enum: ["Free", "Starter", "Professional", "Team", "Company"],
          defaultValue: "Free",
        },
        {
          name: "description",
          type: "longText",
        },
        {
          name: "primaryCTA",
          friendlyName: "Primary CTA",
          type: "object",
          subFields: [
            {
              name: "color",
              type: "string",
              enum: ["primary", "primary-alt", "secondary"],
            },
            {
              name: "text",
              type: "string",
            },
            {
              name: "href",
              type: "string",
              helperText:
                "If left empty, the href will be automatically generated using the selected plan and currency",
            },
          ],
        },
        {
          name: "secondaryCTA",
          friendlyName: "Secondary CTA",
          type: "object",
          subFields: [
            {
              name: "text",
              type: "string",
            },
            {
              name: "href",
              type: "string",
            },
          ],
        },
        {
          name: "features",
          type: "list",
          subFields: [
            { name: "name", type: "string" },
            { name: "href", type: "string" },
            { name: "tooltip", type: "longText" },
          ],
        },
        {
          name: "hideTasks",
          type: "boolean",
        },
        {
          name: "hidePrice",
          type: "boolean",
        },
      ],
    },
  ],
};
